import { usePersonRecommendation } from './api/usePersonRecommendation';
export const useCostPlanEvaluation = ({
  enabled = true
}) => {
  const {
    data: recommendation
  } = usePersonRecommendation({
    enabled,
    perPage: 1,
    isCostPlanBased: true
  });
  return {
    costPlanRecommendation: recommendation?.content[0] || undefined
  };
};